<div class="logs-body de-admin-container">
  <!-- <p class="message">Audit logs coming soon!</p> -->
  <div class="list">
    <h2 class="text-center logs-header heading">Audit Logs</h2>
    <div class="timeline body">
      <nz-timeline *ngIf="logs && logs.length">
        <ng-container *ngFor="let log of logs">
          <nz-timeline-item nzColor="gray" [nzLabel]="left"><span [innerHTML]="log.rightString"></span>
          </nz-timeline-item>
          <ng-template #left><span [innerHTML]="log.leftString"></span></ng-template>
        </ng-container>

      </nz-timeline>
      <div class="more-btn">
        <button nz-button class="button custom-button" [disabled]="disableNext" (click)="getMoreLogs()">
          Load More
        </button>
      </div>

    </div>

  </div>

</div>
